import * as React from 'react';
import { Box, polymorphic } from '../../utils/index.js';
let OverlayComponent = React.forwardRef((props, forwardedRef) => {
  let { content, children, ...rest } = props;
  return React.createElement(
    OverlayWrapper,
    {
      ref: forwardedRef,
      ...rest,
    },
    React.createElement(OverlayOverlay, null, content),
    React.createElement(OverlayHiddenContent, null, children),
  );
});
OverlayComponent.displayName = 'Overlay';
let OverlayHiddenContent = React.forwardRef((props, ref) => {
  let { children, ...rest } = props;
  return React.createElement(
    Box,
    {
      inert: '',
      ref: ref,
      ...rest,
    },
    children,
  );
});
OverlayHiddenContent.displayName = 'Overlay.HiddenContent';
let OverlayOverlay = polymorphic.div('iui-overlay');
OverlayOverlay.displayName = 'Overlay.Overlay';
let OverlayWrapper = polymorphic.div('iui-overlay-wrapper');
OverlayWrapper.displayName = 'Overlay.Wrapper';
export const Overlay = Object.assign(OverlayComponent, {
  Wrapper: OverlayWrapper,
  HiddenContent: OverlayHiddenContent,
  Overlay: OverlayOverlay,
});
